import { render, staticRenderFns } from "./AuthenticationsLayout.vue?vue&type=template&id=faefcdac&scoped=true"
import script from "./AuthenticationsLayout.vue?vue&type=script&lang=js"
export * from "./AuthenticationsLayout.vue?vue&type=script&lang=js"
import style0 from "./AuthenticationsLayout.vue?vue&type=style&index=0&id=faefcdac&prod&lang=scss&scoped=true"
import style1 from "./AuthenticationsLayout.vue?vue&type=style&index=1&id=faefcdac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faefcdac",
  null
  
)

export default component.exports